__turbopack_context__.v({
  "actions": "HS70Aa_actions",
  "container": "HS70Aa_container",
  "content": "HS70Aa_content",
  "description": "HS70Aa_description",
  "errorCode": "HS70Aa_errorCode",
  "errorCodeText": "HS70Aa_errorCodeText",
  "glowOrb1": "HS70Aa_glowOrb1",
  "glowOrb2": "HS70Aa_glowOrb2",
  "primaryButton": "HS70Aa_primaryButton",
  "secondaryButton": "HS70Aa_secondaryButton",
  "stat": "HS70Aa_stat",
  "statDivider": "HS70Aa_statDivider",
  "statLabel": "HS70Aa_statLabel",
  "statValue": "HS70Aa_statValue",
  "statsBar": "HS70Aa_statsBar",
  "subdescription": "HS70Aa_subdescription",
  "title": "HS70Aa_title",
});
